import { ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { getDatabaseUserLink } from '../utils/linkUtils';
import Button from './Button';

const MainNavBar = () => {
    const { user, signOut } = useAuth();

    const handleSignOut = async () => {
        try {
            await signOut();
        } catch (error) {
            console.error('Error signing out:', error);
        }
    };

    // Determine environment
    const environment = import.meta.env.VITE_ENVIRONMENT_NAME || 'staging';

    // Get navbar styling based on environment
    const getNavbarStyles = () => {
        if (environment === 'production') {
            return 'bg-red-500 text-white shadow-md border-b border-red-600';
        } else if (environment === 'development') {
            return 'bg-green-200 text-gray-900 shadow-md border-b border-green-300';
        } else {
            return 'bg-blue-200 text-gray-900 shadow-md border-b border-blue-300';
        }
    };

    // Only show navbar if user is authenticated
    if (!user) {
        return null;
    }

    return (
        <nav className={`w-full ${getNavbarStyles()} sticky top-0 z-50`}>
            <div className="w-full px-4 md:px-6 py-3 md:py-4">
                <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 md:gap-0 max-w-7xl mx-auto">
                    <div className="flex items-center justify-between md:justify-start gap-2 md:gap-4">
                        <h1 className="text-base md:text-xl font-semibold whitespace-nowrap">
                            <Link to="/dashboard">Admin Dashboard</Link>
                        </h1>
                        <span className={`text-xs md:text-sm font-medium px-2 py-1 rounded-md whitespace-nowrap ${environment === 'production'
                            ? 'bg-red-700 text-white'
                            : environment === 'development'
                                ? 'bg-green-300 text-green-900'
                                : 'bg-blue-300 text-blue-900'
                            }`}>
                            {environment.toUpperCase()}
                        </span>
                    </div>

                    <div className="flex items-center justify-between md:justify-end gap-2 md:gap-4">
                        <span className="text-xs md:text-sm truncate max-w-[180px] md:max-w-none">
                            <a href={getDatabaseUserLink(user.uid)} target="_blank" rel="noopener noreferrer">
                                <span className="font-medium flex items-center gap-1 md:gap-2">
                                    <ExternalLink className='w-3 h-3 md:w-4 md:h-4 flex-shrink-0' />
                                    <span className="truncate">{user.displayName || user.email}</span>
                                </span>
                            </a>
                        </span>
                        <Button
                            onClick={handleSignOut}
                            variant="ghost"
                            size="sm"
                            className={`${environment === 'production'
                                ? 'bg-red-700 hover:bg-red-800 text-white'
                                : environment === 'development'
                                    ? 'bg-green-600 hover:bg-green-700 text-white'
                                    : 'bg-blue-600 hover:bg-blue-700 text-white'
                                } text-xs md:text-sm font-medium py-1.5 px-3 md:py-2 md:px-4 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 whitespace-nowrap ${environment === 'production'
                                    ? 'focus:ring-red-500'
                                    : environment === 'development'
                                        ? 'focus:ring-green-500'
                                        : 'focus:ring-blue-500'
                                }`}
                        >
                            Sign Out
                        </Button>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default MainNavBar; 